const ACCESS_TOKEN_KEY = 'biolab_access_token';
const REFRESH_TOKEN_KEY = 'biolab_refresh_token';

// Returns the stored access token from localStorage
export const getAccessToken = () => localStorage.getItem(ACCESS_TOKEN_KEY);

// Returns the stored refresh token from localStorage
export const getRefreshToken = () => localStorage.getItem(REFRESH_TOKEN_KEY);

// Saves both access and refresh tokens to localStorage
export const setTokens = (accessToken, refreshToken) => {
  localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
  localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
};

// Removes both tokens from localStorage
export const clearTokens = () => {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
};

// Decodes the access token JWT payload and returns the user object, or null if invalid
export const getStoredUser = () => {
  const token = getAccessToken();
  if (!token) return null;
  try {
    const payload = token.split('.')[1];
    return JSON.parse(atob(payload));
  } catch {
    return null;
  }
};
